/* eslint-disable vue/no-parsing-error */
/* eslint-disable vue/no-parsing-error */
<template>
  <div>
    <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
              v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
            </b-dropdown-item>
            <b-dropdown-item @click="checkDataExcel(json_data)">
              <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                <i class="fa fa-file-excel-o mr-1" />Export Excel Select
              </download-excel>
            </b-dropdown-item>
            <b-dropdown-item>
              <download-excel :data="dataExport" :fields="json_fields" :name="fileName">
                <i class="fa fa-file-excel-o mr-1" />Export Excel All
              </download-excel>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <a-checkbox @change="getAutoRefresh(refresh)">
              รีเฟรชอัตโนมัติ {{(this.refresh) ? myVal : ''}}
          </a-checkbox>
        </div>
        <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="getDataWithdraw()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
        </div>
    </div>
    <a-table :columns="columns" :dataSource="dataTable" rowKey='withdrawCode' :row-selection="rowSelection" :loading="loadingTable" :scroll="{ x: 1300 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        class="custom-filter-dropdown">
        <a-input v-ant-ref="c => searchInput = c" :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys[0]"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm)"
          style="width: 188px; margin-bottom: 8px; display: block;" />
        <a-button type="primary" @click="() => handleSearch(selectedKeys, confirm)" size="small"
          style="width: 90px; margin-right: 8px">
          Search
        </a-button>
        <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
          Reset
        </a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }" />
      <h6 slot="status" slot-scope="status,record">
        <b-badge href="#" @click="useAction(record.withdrawCode,status)" :loading="isloading" pill
          :variant="getStatus('withdraw',status).color">{{getStatus('withdraw',status).name}}</b-badge>
      </h6>
    </a-table>
    <a-modal title="เลือกบัญชี"  v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
      @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" layout="vertical" :rules="rules">
        <div class="row">
          <div class="col-md-12">
            <a-form-model-item label="บัญชีถอน" prop="account">
            <a-select v-model="form.account"  show-search placeholder="กรุณาเลือกบัญชี" style="width: 100%">
              <a-select-option value="">
                กรุณาเลือกบัญชี
              </a-select-option>
              <a-select-option v-for="(item , index) in dataAccount" :key="index" :value="item.id">
                {{ item.name }}:{{item.accountName}}({{item.accountNumber}}) -> {{parseFloat(item.balance).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }} บาท
              </a-select-option>
            </a-select>
            </a-form-model-item>
          </div>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal v-model="modelShowDetail" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <dl class="row" v-if="loadingModal !== true">
          <dt class="col-sm-4">รหัสธุรกรรม :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.transectionCode)?"ไม่พบข้อมูล":this.datatransection.transectionCode }}</dd>

          <dt class="col-sm-4">บัญชีลูกค้า :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection.userBankTranfer }}</dd>

          <dt class="col-sm-4">บัญชีระบบ :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection.systemBankTranfer }}</dd>

          <dt class="col-sm-4 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.amount)?"ไม่พบข้อมูล":this.datatransection.amount }}</dd>

          <dt class="col-sm-4">เวลาที่โอนเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.datetimeTranfer)?"ไม่พบข้อมูล": this.datatransection.datetimeTranfer }}</dd>

          <dt class="col-sm-4">สถานะ :</dt>
          <dd class="col-sm-8"><b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">{{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge></dd>

          <dt class="col-sm-4">รายละเอียด :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.detail)?"ไม่พบข้อมูล":this.datatransection.detail }}</dd>

          <dt class="col-sm-4">บัญชีจากธนาคาร :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.detailBankNumber)?"ไม่พบข้อมูล":this.datatransection.detailBankNumber }}</dd>

          <dt class="col-sm-4">หมายเหตุ :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.remark)?"ไม่พบข้อมูล":this.datatransection.remark }}</dd>
        </dl>
      </div>
    </a-modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import momentTz from 'moment-timezone'
import moment from 'moment'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    data: {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
    },
  },
  props: [
    'isReload',
  ],
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
      getSelectUser: 'getSelectUser',
      getSelectStatus: 'getSelectStatus',
      getKeyword: 'getKeyword',
      getKeywordTime: 'getKeywordTime',
      getSearchUpdate: 'getSearchUpdate',
    }),
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.withdrawCode
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getDataWithdraw()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getSelectOperator: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    getSelectUser: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    getSelectStatus: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    getKeyword: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    getKeywordTime: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    getSearchUpdate: function(val) {
      if (val) {
        this.getDataWithdraw()
      }
    },
    isReload() {
      if (this.isReload) {
        this.reloadTable()
      }
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },
  data() {
    return {
      checkFistPage: true,
      loadingActive: true,
      loadingModal: false,
      json_data: [],
      json_fields: {
        รหัสธุรกรรม: 'withdrawCode',
        รหัสสมาชิก: 'username',
        บัญชีลูกค้า: 'bankServiceUser',
        บัญชีระบบ: 'bankServiceSystem',
        จำนวนเงิน: 'amount',
        สถานะ: 'withdrawStatus',
        วันที่สร้าง: 'createdAt',
      },
      fileName: 'รายการธุรกรรมถอนเงิน' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
      modelShowDetail: false,
      dataTable: [],
      dataExport: [],
      loadingTable: false,
      datatransection: {},
      isloading: false,
      selectedRowKeys: [],
      refresh: false,
      countdown: false,
      counters: '',
      counters2: '',
      ctr: 5,
      dataAccount: '',
      visible: false,
      form: {
        account: '',
        withdrawCode: '',
      },
      rules: {
        account: [{ required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' }],
      },
      columns: [
        {
          title: 'รหัสธุรกรรม',
          key: 'withdrawCode',
          dataIndex: 'withdrawCode',
          width: 200,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'withdrawCode',
          },
          onFilter: (value, record) => record.withdrawCode.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'คู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          width: 200,
          // scopedSlots: {
          //   filterDropdown: 'filterDropdown',
          //   filterIcon: 'filterIcon',
          //   customRender: 'operatorName',
          // },
          filters: [],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'รหัสสมาชิก',
          key: 'username',
          dataIndex: 'username',
          width: 200,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'username',
          },
          onFilter: (value, record) => record.username.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชีลูกค้า',
          key: 'bankServiceUser',
          dataIndex: 'bankServiceUser',
          width: 200,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'bankServiceUser',
          },
          onFilter: (value, record) => record.bankServiceUser.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชีระบบ',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          width: 200,
        },
        {
          title: 'จำนวนเงิน',
          key: 'amount',
          dataIndex: 'amount',
          customRender: (text, row, index) => {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
          width: 150,
          fixed: 'right',
        },
        {
          title: 'สถานะ',
          key: 'status',
          dataIndex: 'withdrawStatus',
          scopedSlots: { customRender: 'status' },
          width: 150,
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',
        },
      ],
    }
  },
  methods: {
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.withdrawCode === result) {
              return true
            }
          })
          const resultData = {
            withdrawCode: item.withdrawCode,
            username: item.username,
            bankServiceUser: item.bankServiceUser,
            bankServiceSystem: item.bankServiceSystem,
            amount: item.amount,
            withdrawStatus: this.getStatus('withdraw', item.withdrawStatus).name,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    exportAll (obj) {
      this.dataExport = []
      let resultData = {}
      obj.map(element => {
        resultData = {
          withdrawCode: element.withdrawCode,
          username: element.username,
          bankServiceUser: element.bankServiceUser,
          bankServiceSystem: element.bankServiceSystem,
          amount: element.amount,
          withdrawStatus: this.getStatus('withdraw', element.withdrawStatus).name,
          createdAt: moment(element.createdAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        this.dataExport.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.withdrawCode === result) {
              return true
            }
          })
          const resultData = {
            withdrawCode: item.withdrawCode,
            username: item.username,
            bankServiceUser: item.bankServiceUser,
            bankServiceSystem: item.bankServiceSystem,
            amount: item.amount,
            withdrawStatus: this.getStatus('withdraw', item.withdrawStatus).name,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    useModal(e) {
      this.modelShowDetail = !this.modelShowDetail
    },
    async getDataWithdraw() {
      this.data = []
      const dataDeposit = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
        username: this.getSelectUser,
        status: this.getSelectStatus,
        keyword: this.getKeyword,
        keywordTime: this.getKeywordTime,
        type: 'commission',
        searchUpdate: this.getSearchUpdate,
      }
      this.loadingTable = !this.loadingTable
      await apiClient.post('/withdraw/getData', dataDeposit).then(response => {
        this.loadingTable = !this.loadingTable
        const res = response.data
        if (res.code === '000') {
          this.dataTable = res.responseData.data
          this.exportAll(res.responseData.data)
          if (this.dataTable.length > 0) {
            const listOperater = this.dataTable.map(function(item, pos) {
              return { text: item.operatorName, value: item.operatorName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async reloadTable() {
      await this.getDataWithdraw()
      await this.$emit('isReload-table')
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    useAction(withdrawCode, status) {
      if (status === '001') this.checkWithdraw(withdrawCode)
      if (status === '005') this.reStatus(withdrawCode)
      if (status === '000') this.showSucces(withdrawCode)
    },
    checkWithdraw(withdrawCode) {
      Swal.fire({
        icon: 'info',
        title: 'ต้องการยืนยันรายการหรือยกเลิกรายการ?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'ยืนยันรายการ',
        denyButtonText: 'ยกเลิกรายการ',
        denyButtonColor: '#d33',
        cancelButtonText: 'ปิด',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.confirmWithdraw(withdrawCode)
        } else if (result.isDenied) {
          this.cancelWithdraw(withdrawCode)
        }
      })
    },
    async confirmWithdraw(withdrawCode) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการถอนเงินรายการนี้',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.post('/withdraw/confirmWithdraw', { withdrawCode: withdrawCode }).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error.message}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getDataWithdraw()
        }
      })
    },
    async cancelWithdraw(withdrawCode) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการยกเลิกรายการนี้',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.post('/withdraw/cancelWithdraw', { withdrawCode: withdrawCode }).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error.message}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getDataWithdraw()
        }
      })
    },
    async reStatus(withdrawCode) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการรีสถานะหรือเปลี่ยนบัญชีการถอนเงิน',
        showDenyButton: true,
        showCancelButton: true,
        cancelButtonColor: '#d14529',
        denyButtonColor: '#3a9ae6',
        denyButtonText: 'เปลี่ยนบัญชี',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'รีสถานะ',
      }).then((result) => {
        if (result.isConfirmed) {
          const data = { withdrawCode: withdrawCode }
          return apiClient.post('/withdraw/reStatusWithdrawError', data).then(response => {
            const res = response.data
            if (res.code === '000') {
              const getData = res.message
              const iconError = (res.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: getData })
            } else {
              const getData = res.message
              const iconError = (res.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: getData })
            }
            this.getDataWithdraw()
          }).catch(error => {
            Swal.showValidationMessage(
              `Request failed: ${error}`,
            )
          })
        } else if (result.isDenied) {
          const data = { withdrawCode: withdrawCode }
          this.changeAccount(data)
        }
      })
    },
    changeAccount(data) {
      this.clearForm()
      return apiClient.post('/withdraw/checkAccountWithdrawCommission', data).then(response => {
        const res = response.data
        if (res.code === '000') {
          const getData = res.responseData.data
          this.visible = true
          // this.form.account = ''
          this.dataAccount = getData
          this.form.withdrawCode = data.withdrawCode
        } else if (res.code === '006' || res.code === '001') {
          const getData = res.message
          const iconError = (res.code.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: getData })
        }
        this.getDataWithdraw()
      }).catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`,
        )
      })
    },
    async showSucces(withdrawCode) {
      this.useModal()
      this.loadingModal = !this.loadingModal
      this.loadingActive = true
      await apiClient.get(`/withdraw/getTransection/${withdrawCode}`).then(response => {
        const res = response.data
        if (res.code === '000') {
          const getData = res.responseData.data[0]

          const getnameStatus = getName('bankPayment', getData.transectionStatus)

          this.datatransection = {
            transectionCode: getData.transectionCode,
            amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            userBankTranfer: getData.bankServiceUser,
            systemBankTranfer: getData.bankServiceSystem,
            status: getnameStatus[0].name,
            color: getnameStatus[0].color,
            detail: getData.detail,
            detailBankNumber: getData.detailBankNumber,
            remark: getData.remark,
            datetimeTranfer: moment(getData.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
          }
        }
        this.loadingModal = !this.loadingModal
        this.loadingActive = false
      }).catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`,
        )
      })
    },
    handleOk(e) {
      this.onSubmit(e)
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = 'แน่ใจหรือไม่ที่ต้องการแก้ไขบัญชี'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                const data = {
                  withdrawCode: this.form.withdrawCode,
                  bankServiceId: this.form.account,
                }
                return apiClient.post('/withdraw/updateAccount', data).then(response => {
                  if (response.status !== 200) {
                    throw new Error(response.message)
                  }
                  return response.data
                }).catch(error => {
                  Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error.message}`,
                  )
                })
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.getDataWithdraw()
            }
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    },
    clearForm() {
      this.form = {
        account: '',
        withdrawCode: '',
      }
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    ReloadData (value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.getDataWithdraw()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reCountdown () {
      this.ctr = 5
    },
  },
  async created() {
    // await this.getDataWithdraw()
  },
}
</script>

<style>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.badge.badge-custom {
    background: #ff5722;
    color: #fff;
}
</style>
